<mat-form-field class="improved-select">
  <mat-select
    [formControl]="selectControl"
    [disabled]="disabled"
    (openedChange)="!$event && hasSearch && clearSearch()"
    (selectionChange)="handleSelectOption($event)"
  >
    @if (hasSearch) {
    <mat-form-field class="search">
      <mat-icon matPrefix>search</mat-icon>
      <input matInput [formControl]="searchControl" [placeholder]="'BUTTONS.SEARCH' | translate" (keydown)="$event.stopPropagation()" />
    </mat-form-field>
    } @if (optionsListLoading) {
    <div class="spinnerSearchWrapper">
      <mat-spinner class="spinnerSearch" strokeWidth="2" diameter="20"></mat-spinner>
    </div>
    } @else {
    <div class="options-list" linPerfectScrollbar (scroll)="onScroll($event)">
      @if (!required) {
      <mat-option value=""></mat-option>
      } @if (pinnedOption) {
      <mat-option disabled [value]="pinnedOptionValue"> {{ displayOptionLabel(pinnedOption) }} </mat-option>
      } @for (option of filteredOptions; track option[optionValueKey]) { @if (!option.hidden) {
      <mat-option [value]="option[optionValueKey]" [disabled]="option.disabled"> {{ displayOptionLabel(option) }} </mat-option>
      } } @if (loadingMoreOptions) {
      <mat-spinner class="spinner" strokeWidth="2" diameter="20" color="accent"></mat-spinner>
      }
    </div>
    }
  </mat-select>

  <mat-error>
    <lin-form-field-error [control]="control" [controlName]="controlName"></lin-form-field-error>
  </mat-error>
</mat-form-field>
